export default __webpack_public_path__ + "static/media/promo-banner-tiger-lunar.101c6d8f.svg";